<template>
  <form
    class="space-y-1"
    novalidate
    @submit.prevent="$emit('submit')"
  >
    <slot />
  </form>
</template>

<script setup lang="ts">
defineEmits(['submit'])
</script>
